import { useState, useEffect, useRef } from 'react';
import envConfig from '../utils/config';

export interface OrganizationDetails {
  orgDisplayName: string;
  logo: string;
  icon: string;
  b2cLink: string;
  googleDeepLink: string;
  appDeepLink: string;
  qrCode: string;
  logoMobile: string;
}

const ApiKey = envConfig.REACT_APP_ADMIN_X_API_KEY;
export const useFetchOrganizationDetails = () => {
  const [data, setData] = useState<OrganizationDetails | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const isFetched = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      const fullUrl = window.location.href;
      const urlWithoutProtocol = fullUrl
        .replace(/^https?:\/\//, '')
        .replace(/\/$/, '');
      const baseDomain = urlWithoutProtocol.split('/')[0];

      try {
        const res = await fetch(
          `${envConfig.REACT_APP_ADMIN_BASE_URL}/pmo/b/g/d`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': ApiKey,
            },
            body: JSON.stringify({
              b2cLink: baseDomain,
            }),
          }
        );

        if (!res.ok) {
          throw new Error('Failed to fetch organization details');
        }

        const data = await res.json();
        setData(data);
      } catch (error: any) {
        setError(error.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };
    if (!isFetched.current && !data) {
      isFetched.current = true;
      fetchData();
    }
  }, [data]);

  return { data, loading, error };
};
